import { connect } from "react-redux";
import { getUsers } from "../../store/actions/user.actions";
import { project } from "../../store/selectors/projects.selector";
import {
  resources,
  loading,
  resourcesPagination,
} from "../../store/selectors/allocatedResources.selector";
import {
  getResourcesRequest,
  // deleteResourceRequest,
} from "../../store/actions/allocatedResources.actions";
import AllocatedResources from "./AllocatedResources";
const mapDispatchToProps = {
  getResourcesRequest,
  // deleteResourceRequest,
  getUsersRequest: getUsers,
};
const mapStateToProps = (state) => {
  return {
    projectDetails: project(state),
    allAllocatedResources: resources(state),
    pageLoading: loading(state),
    pagination: resourcesPagination(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AllocatedResources);
